/**
 * UUID v4-berbentuk yang deterministik untuk seed: `<group 8 hex>-0000-4000-8000-<n 12 hex>`.
 * Seed yang sama selalu menghasilkan id yang sama sehingga relasi antar-tabel stabil.
 */
export const seedId = (group: number, n: number) =>
  `${group.toString(16).padStart(8, '0')}-0000-4000-8000-${n.toString(16).padStart(12, '0')}`

export const SEED_GROUP = {
  role: 0x101,
  user: 0x102,
  privilege: 0x103,
  product: 0x104,
  module: 0x105,
  cluster: 0x106,
  page: 0x107,
  productPage: 0x108,
  capability: 0x109,
  workflow: 0x201,
  wmlStatus: 0x202,
  wmlActor: 0x203,
  wmlComponent: 0x204,
  wmlAction: 0x205,
  wmlActionActor: 0x206,
  wmlPanel: 0x207,
  wmlPanelActor: 0x208,
  wxlSubmission: 0x209,
  wxlSubmissionLog: 0x20a,
  materialGroup: 0x301,
  unit: 0x302,
  material: 0x303,
  company: 0x304,
  packStandard: 0x305,
  warehouse: 0x306,
  rmUnit: 0x307,
  machine: 0x308,
  sku: 0x309,
  purchaseRequest: 0x401,
  purchaseRequestLine: 0x402,
  materialRequest: 0x403,
  materialRequestLine: 0x404,
  warehouseZone: 0x501,
  rack: 0x502,
  rackBin: 0x503,
  arrival: 0x504,
  arrivalLine: 0x505,
  pallet: 0x506,
  palletContent: 0x507,
  quarantineEntry: 0x508,
  qcAssignment: 0x509,
  tobaccoReceipt: 0x50a,
  tobaccoReceiptLine: 0x50b,
  putawayTask: 0x50c,
  putawayTaskItem: 0x50d,
  rejectType: 0x50e,
  ngTicket: 0x50f,
  returnOrder: 0x510,
  returnOrderLine: 0x511,
  ngPickupTask: 0x512,
  pickingTask: 0x520,
  pickingTaskItem: 0x521,
  handover: 0x522,
  billOfMaterial: 0x523,
  transfer: 0x530,
  transferLine: 0x531,
  wipReturn: 0x532,
  wipReturnLine: 0x533,
  tobaccoReturn: 0x534,
  tobaccoReturnLine: 0x535,
  fgBatch: 0x540,
  fgLabel: 0x541,
  fgFeedLog: 0x542,
  fgPutawayTask: 0x543,
  fgPutawayItem: 0x544,
  fgPackStock: 0x545,
  container: 0x546,
  deliveryPlan: 0x550,
  deliveryPlanLine: 0x551,
  fgPickingTask: 0x552,
  fgPickingItem: 0x553,
  fgStaging: 0x554,
  fgRtsTask: 0x555,
  fgRtsItem: 0x556,
  mergeRequest: 0x560,
  mergeRequestItem: 0x561,
  consolidationTask: 0x562,
  consolidationTaskItem: 0x563,
  claimArrivalPlan: 0x570,
  claimArrivalPlanLine: 0x571,
  claimReceipt: 0x572,
  claimReceiptScan: 0x573,
  claimReceiptOperator: 0x574,
  claim: 0x575,
  claimItem: 0x576,
  claimSortTask: 0x577,
  claimStoreTask: 0x578,
  fgNgPack: 0x579,
  initialCaptureSession: 0x580,
  initialCaptureArea: 0x581,
  rmOpeningStock: 0x582,
  rmMoveTask: 0x583,
  rmMoveTaskItem: 0x584,
  rmNgItem: 0x585,
  txLog: 0x586,
  stockMovement: 0x587,
  fgDestruction: 0x588,
  fgDestructionTask: 0x589,
  fgDestructionTaskLine: 0x58a,
  rmDestruction: 0x58b,
  initialCaptureScan: 0x58c,
  opnameSchedule: 0x590,
  opnameSession: 0x591,
  opnameTask: 0x592,
  opnameScan: 0x593,
  discrepancy: 0x594,
  sla: 0x5a0,
  notification: 0x5b0
} as const
